import React, {useState, useEffect} from 'react'

const ActionResultPanel = props =>{

    const [actionResult,setActionResult] = useState(props.actionResult);
  
    useEffect(()=>{
      setActionResult(props.actionResult)
    },[props.actionResult]);
  
    return(<div
      className={
        actionResult === ""
          ? "hide  action-message"
          : `${actionResult} action-message`
      }
    >
      <i
        className={
          actionResult === "success"
            ? "fa fa-check-circle"
            : "fa fa-times-circle"
        }
      ></i>
  
      <span>
        {actionResult === "success"
          ? "Opération réussie"
          : "Échec de l'opération"}
      </span>
    </div>);
  }

  export default ActionResultPanel;